var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo-page"},[_c('RewardFlow')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }